import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography, Paper, Stack } from '@mui/material';
import Footer from '../componentsPeopletech/Footer/Footer';

const TestPage = () => {
  return (
    <>
      <Helmet>
        <title>Test Page - PeopleForTech</title>
        <meta name="description" content="Página de test para verificar el funcionamiento del routing" />
      </Helmet>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Container maxWidth="md" sx={{ py: 8, flex: 1 }}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              textAlign: 'center',
            }}
          >
            <Stack spacing={3}>
              <Typography variant="h2" component="h1" color="primary">
                🧪 Página de Test
              </Typography>
              <Typography variant="h5" color="text.secondary">
                Esta es una página de prueba
              </Typography>
              <Box
                sx={{
                  mt: 4,
                  p: 3,
                  backgroundColor: '#e3f2fd',
                  borderRadius: 2,
                }}
              >
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong>Información de la página:</strong>
                </Typography>
                <Typography variant="body2" component="div">
                  <ul style={{ textAlign: 'left', display: 'inline-block' }}>
                    <li>Ruta: <code>/test</code></li>
                    <li>Componente: <code>TestPage.js</code></li>
                    <li>Fecha de creación: {new Date().toLocaleDateString()}</li>
                    <li>Estado: ✅ Funcionando</li>
                  </ul>
                </Typography>
              </Box>
              <Box
                sx={{
                  mt: 2,
                  p: 2,
                  backgroundColor: '#f1f8e9',
                  borderRadius: 2,
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  Si puedes ver esta página, significa que el routing está funcionando correctamente.
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </Container>
        <Footer />
      </Box>
    </>
  );
};

export default TestPage;

